export default __webpack_public_path__ + "static/media/bonus-info-icon.1a4e9a11.svg";